import React from 'react';
import { motion } from 'framer-motion';
interface LazySectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export function LazySection({
  children,
  className = '',
  id
}: LazySectionProps) {
  return <motion.section id={id} className={`section-padding relative ${className}`} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} data-id="element-204">
      {children}
    </motion.section>;
}